import { render, staticRenderFns } from "./CategoryInput.vue?vue&type=template&id=f525229a&scoped=true&"
import script from "./CategoryInput.vue?vue&type=script&lang=js&"
export * from "./CategoryInput.vue?vue&type=script&lang=js&"
import style0 from "./CategoryInput.vue?vue&type=style&index=0&id=f525229a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f525229a",
  null
  
)

export default component.exports